import StoreType, { STATE_TYPE_OF_DEVICE } from "@/store/StoreType";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import device from "@/api/device";

import log from "@/util/log";
import user from "@/api/user";

const KEY_B_HOME_TAG = "b_tag";
const KEY_C_HOME_TAG = "c_tag";
const KEY_NICO_HOME_TAG = "nico_tag";
const KEY_DEVICE_CURVE = "device_curve";
export const NfcStore = {
  namespaced: true,
  state: {
    nfcDeviceOilBattery: null,//{ currentSecond:'8403',battery:'D80E',maxSecond:'08e3' },
    writerSetting: new WriterSetting(),
    level: 0,
    typeOfDevice: 0,
    defaultBHomeData: (() => {
      try {
        const json = JSON.parse(localStorage.getItem(KEY_B_HOME_TAG));
        if (!json) {
          throw e;
        }
        return json;
      } catch (e) {
        if (process.env.NODE_ENV === "dev1") {
          return {
            tagId: "0989236299263892963",
            isDefaultData: true,
            deviceName: "FöRBIDDEN ",
            commodityLabelId: "Hybird",
            ingredientsVoList: [
              {
                id: 1,
                proportion: 24,
                name: "Delta 8"
              },
              {
                id: 2,
                proportion: 26,
                name: "HHC"
              },
              {
                id: 3,
                proportion: 40,
                name: "Delta 9"
              },
              {
                id: 4,
                proportion: 10,
                name: "Delta8"
              }
            ],

            flavorPicture: require("@/assets/icons/consumer/ic_default_device.png")


          };
        }
        return null;
      }
    })(),
    defaultCHomeData: (() => {
      try {
        const json = JSON.parse(localStorage.getItem(KEY_C_HOME_TAG));
        if (!json) {
          throw e;
        }
        return json;
      } catch (e) {
        if (process.env.NODE_ENV === "dev1") {
          return {
            isDefaultData: true,
            tagId: "0989236299263892963",
            deviceName: "FöRBIDDEN ",
            commodityLabelId: "Hybird",
            ingredientsVoList: [
              {
                id: 1,
                proportion: 24,
                name: "Delta 8"
              },
              {
                id: 2,
                proportion: 26,
                name: "HHC"
              },
              {
                id: 3,
                proportion: 40,
                name: "Delta 9"
              },
              {
                id: 4,
                proportion: 10,
                name: "Delta8"
              }
            ],
            terpenesList: [],
            flavorPicture: require("@/assets/icons/consumer/ic_default_device.png")
          };
        }
        return null;
      }
    })(),

    defaultNicoData: (() => {
      try {
        const json = JSON.parse(localStorage.getItem(KEY_NICO_HOME_TAG));
        if (!json) {
          throw e;
        }
        return json;
      } catch (e) {
        if (process.env.NODE_ENV === "dev") {
          return {
            isDefaultData: true,
            deviceName: "FöRBIDDEN FRUIT FAVE",
            commodityLabelId: "Hybird",
            ingredientsVoList: [
              {
                id: 1,
                proportion: 24,
                name: "Delta 8"
              },
              {
                id: 2,
                proportion: 26,
                name: "HHC"
              },
              {
                id: 3,
                proportion: 40,
                name: "Delta 9"
              },
              {
                id: 4,
                proportion: 10,
                name: "Delta8"
              }
            ],
            terpenesList: [],
            flavorPicture: require("@/assets/icons/consumer/ic_default_device.png"),
            tagId: "0989236299263892963"
          };
        }
        return null;
      }
    })(),
    deviceCurve: (()=> {
      try {
        const json = JSON.parse(localStorage.getItem(KEY_DEVICE_CURVE));
        if (!json) {
          throw e;
        }
        return json;
      } catch (e) {

      }
      return [[1, 4.2], [2, 3.8], [3, 1.8], [4, 4.3], [5, 4.5], [6, 8.5], [7, 6.5], [8, 6.1]]
    })()
  },
  mutations: {
    [StoreType.COMMIT_TYPE.STATE_NFC_DEVICE_OIL_BATTERY](state, payload) {
      state.nfcDeviceOilBattery = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING](state, payload) {
      state.writerSetting = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_LEVEL](state, payload) {
      state.level = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TYPE_OF_DEVICE](state, payload) {
      state.typeOfDevice = payload;
    },
    setDefaultBusinessTagData(state, payload) {
      localStorage.setItem(KEY_B_HOME_TAG, JSON.stringify(payload));
      state.defaultBHomeData = payload;
    },
    setDefaultConsumerTagData(state, payload) {
      localStorage.setItem(KEY_C_HOME_TAG, JSON.stringify(payload));
      state.defaultCHomeData = payload;
    },
    setDefaultNicoTagData(state, payload) {
      localStorage.setItem(KEY_NICO_HOME_TAG, JSON.stringify(payload));
      state.defaultNicoData = payload;
    },
    setDeviceCurve(state, payload) {
      localStorage.setItem(KEY_DEVICE_CURVE, JSON.stringify(payload));
      state.deviceCurve = payload

    }
  },
  actions: {
    async activeTag({ state }, tagId) {
      try {
        const resp = await device.activeTag(tagId);
      } catch (e) {
        log(e);
      }
    },
    async uploadUserUsageHistory({ state }, { tagId, battery, currentSeconds, maxSeconds }) {
      try {
        const resp = await device.uploadUserUsageHistory({
          cartridgeMac: "",
          currentBattery: battery,
          currentSeconds: currentSeconds,
          maxSeconds: maxSeconds,
          tag: tagId
        });
      } catch (e) {
        log(e);
      }
    },
    async checkShowNfcGuide({ state, rootGetters }) {
      const isBrandUser = rootGetters["user/isBrandUser"];
      const key = isBrandUser ? "show_nfc_guide" : "show_c_nfc_guide";
      const showNfcGuide = localStorage.getItem(key);
      return !showNfcGuide;
    },
    async setShowNfcGuide({ state, rootGetters }, payload) {
      const isBrandUser = rootGetters["user/isBrandUser"];
      const key = isBrandUser ? "show_nfc_guide" : "show_c_nfc_guide";
      localStorage.setItem(key, payload);
    },
    async saveCurve({ state, commit }, payload) {
      commit("setDeviceCurve", payload);
    }
  },
  getters: {}
};